module.exports = __webpack_public_path__ + "img/copy.fd5e467b.svg";